import { branch, compose, renderNothing } from 'recompose';
import withTimeTrackingEnabled from './withTimeTrackingEnabled';

const showForTimeTrackingEnabled = compose(
  withTimeTrackingEnabled,
  branch(
    props => !props.timeTrackingEnabled,
    renderNothing,
  )
);

export default showForTimeTrackingEnabled;
